export const forceImageHttps = (image) => {
  if (typeof image === 'string') {
    return image.replace(/^http:/g, 'https:');
  }
  return image;
};
